import * as rp from 'request-promise';
import { IPerson } from 'types/registration';

interface IRegisterForm {
  to: string;
  event: string;
  team: {
    name: string;
    province: string;
    stadium: string;
  };
  captain: IPerson;
  players: IPerson[];
  reserves: IPerson[];
}

export const sendRegisterEmail = (email: IRegisterForm) => {

  const uri = (process.env.REACT_APP_FUNCTIONS_ENDPOINT || '') + '/register';
  const options: rp.Options = {
    body: email,
    json: true,
    method: 'POST',
    uri
  };
  return rp(options);
};



// WEBPACK FOOTER //
// ./src/utils/sendRegisterEmail.ts